import { fetchGet, fetchPost } from './fetch';

const API_URL = '';

interface GetShareAudioResponse {
  data: {
    id: string;
    user: {
      name: string;
    };
    name: string;
    cdn_path: string;
    album_cover: string;
    duration: number;
  };
}

export const getShareAudio = async (req: { id?: string }): Promise<GetShareAudioResponse> => {
  const url = `${API_URL}/api/v1/audio/sharing_audio/:id`;
  return fetchGet<GetShareAudioResponse>(url, req, undefined);
};

interface GetPrivateShareAudioResponse {
  data: {
    id: string;
    user: {
      name: string;
    };
    name: string;
    url: string;
    source_url: string;
    album_cover: string;
    duration: number;
  };
}

export const getPrivateShareAudio = async (req: { id?: string }): Promise<GetPrivateShareAudioResponse> => {
  const url = `${API_URL}/api/v2/audio/private_sharing_detail/:id`;
  return fetchGet<GetPrivateShareAudioResponse>(url, req, undefined);
};
